AGA.Events = (function () {
    var _eventsHash = {};

    const internalOn = function (eventName, callback) {
        if (typeof callback !== "function") {
            throw new Error("Callback must be a function!");
        }
        if (!_eventsHash[eventName]) {
            _eventsHash[eventName] = [];
        }
        _eventsHash[eventName].push(callback);
    };

    const internalOff = function (eventName, callback) {
        if (!_eventsHash[eventName]) return;
        if (callback) {
            _eventsHash[eventName] = _eventsHash[eventName].filter(fn => fn !== callback);
        }
    };

    const internalInvoke = function (eventName, args) {
        if (!_eventsHash[eventName]) return;

        // Payload para o evento
        var e = {
            eventName: eventName,
            stopPropagation: false,
            target: args
        };
        
        _eventsHash[eventName].forEach(callback => {
            try {
                if (!e.stopPropagation) {
                    callback(e);
                }

            } catch (error) {
                console.error(`Error invoking event ${eventName}:`, error);
            }
        });
    };

    return {
        // Adiciona callback ao evento especificado ex:  on("myEvent", myFunction);
        on: internalOn,
        
        // Remove callback do evento especificado ex:  off("myEvent", myFunction);
        off: internalOff,

        // Dispara o evento com os parametros ex:  invoke("myEvent", { a: 1, b: 2 });
        invoke: internalInvoke,
    };
})();

